import React, { FC, PropsWithChildren, ReactNode } from 'react'

type LayoutProps = {
  topNavComponent?: ReactNode
  sideMenuComponent?: ReactNode
}
const Layout: FC<PropsWithChildren<LayoutProps>> = ({ children, topNavComponent, sideMenuComponent }) => {
  return (
    <div className='h-screen'>
      <>{topNavComponent}</>
      <div className='w-full h-[calc(100vh_-4.185rem)] flex overflow-hidden'>
        {sideMenuComponent && <>{sideMenuComponent}</>}
        <div className='grow overflow-hidden'>{children}</div>
      </div>
    </div>
  )
}

export default Layout
